import * as React from "react";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import { setCurrentUser, User, logoutUser } from "utils/user";
import Spinner from "./Common/Spinner";
import ExcelAddIn from "./ExcelAddIn";
import { styles } from "./styles";
import Login from "./Login";
import GetStarted from "./GetStarted";

interface AppProps extends WithStyles<typeof styles> {
  title: string;
  isOfficeInitialized: boolean;
}

interface AppState {
  isAuthenticated: boolean;
  user: User | null;
  showSpinner: boolean;
  showGetStarted: boolean;
  Snackbar: boolean;
  isDelay: boolean;
  wsClient: any;
}

class App extends React.Component<AppProps & WithStyles<typeof styles>, AppState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isAuthenticated: false,
      user: null,
      showSpinner: false,
      showGetStarted: true,
      Snackbar: false,
      isDelay: false,
      wsClient: null,
    };
  }

  setShowSpinner = (showSpinner: boolean) => {
    this.setState({
      showSpinner,
    });
  };

  setUser = (user: User) => {
    if (user) {
      setCurrentUser(user);
      this.setState({
        user: user,
        isAuthenticated: true,
      });
    }
  };

  logOutUser = () => {
    this.state.wsClient.close();
    logoutUser();
    this.setState({
      user: null,
      isAuthenticated: false,
      wsClient: null,
    });
  };

  onClickGetStarted = () => {
    this.setState({
      showGetStarted: false,
    });
  };

  setDelay = (bool: boolean) => {
    this.setState({
      isDelay: bool,
    });
  };

  handleWsClient = (socket) => {
    this.setState({
      wsClient: socket,
    });
  };

  render() {
    const { isAuthenticated, showSpinner, showGetStarted } = this.state;
    const { classes } = this.props;

    if (showGetStarted) {
      return <GetStarted onClickGetStarted={this.onClickGetStarted} />;
    }

    return (
      <div className={classes.root}>
        {isAuthenticated ? (
          <>
            <ExcelAddIn
              logOutUser={this.logOutUser}
              setShowSpinner={this.setShowSpinner}
              isDelay={this.state.isDelay}
            />
          </>
        ) : (
          <Login
            setUser={this.setUser}
            setShowSpinner={this.setShowSpinner}
            setDelay={this.setDelay}
            handleWsClient={this.handleWsClient}
            logOutUser={this.logOutUser}
          />
        )}

        {showSpinner && <Spinner />}
      </div>
    );
  }
}

export default withStyles(styles)(App);
